/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimFinancialRow
 */
export interface ClaimFinancialRow {
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialRow
     */
    claimId: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimFinancialRow
     */
    claimNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimFinancialRow
     */
    insuredName: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimFinancialRow
     */
    createdAt: string;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialRow
     */
    rcvCents: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialRow
     */
    depreciationCents: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialRow
     */
    acvCents: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialRow
     */
    deductibleCents: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialRow
     */
    netClaimCents: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialRow
     */
    recoverableDepreciationCents: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialRow
     */
    nonRecoverableDepreciationCents: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialRow
     */
    netWithRecoverableCents: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialRow
     */
    totalPaymentsCents: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialRow
     */
    carrierPaymentCents: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialRow
     */
    supplementPaymentCents: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialRow
     */
    depreciationReleaseCents: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialRow
     */
    mortgageReleaseCents: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialRow
     */
    otherPaymentCents: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimFinancialRow
     */
    feeType: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialRow
     */
    feePercentage: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialRow
     */
    flatFeeCents: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialRow
     */
    expectedFeeCents: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialRow
     */
    actualFeeCents: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialRow
     */
    outstandingFeeCents: number;
}

/**
 * Check if a given object implements the ClaimFinancialRow interface.
 */
export function instanceOfClaimFinancialRow(value: object): value is ClaimFinancialRow {
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('claimNumber' in value) || value['claimNumber'] === undefined) return false;
    if (!('insuredName' in value) || value['insuredName'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('rcvCents' in value) || value['rcvCents'] === undefined) return false;
    if (!('depreciationCents' in value) || value['depreciationCents'] === undefined) return false;
    if (!('acvCents' in value) || value['acvCents'] === undefined) return false;
    if (!('deductibleCents' in value) || value['deductibleCents'] === undefined) return false;
    if (!('netClaimCents' in value) || value['netClaimCents'] === undefined) return false;
    if (!('recoverableDepreciationCents' in value) || value['recoverableDepreciationCents'] === undefined) return false;
    if (!('nonRecoverableDepreciationCents' in value) || value['nonRecoverableDepreciationCents'] === undefined) return false;
    if (!('netWithRecoverableCents' in value) || value['netWithRecoverableCents'] === undefined) return false;
    if (!('totalPaymentsCents' in value) || value['totalPaymentsCents'] === undefined) return false;
    if (!('carrierPaymentCents' in value) || value['carrierPaymentCents'] === undefined) return false;
    if (!('supplementPaymentCents' in value) || value['supplementPaymentCents'] === undefined) return false;
    if (!('depreciationReleaseCents' in value) || value['depreciationReleaseCents'] === undefined) return false;
    if (!('mortgageReleaseCents' in value) || value['mortgageReleaseCents'] === undefined) return false;
    if (!('otherPaymentCents' in value) || value['otherPaymentCents'] === undefined) return false;
    if (!('feeType' in value) || value['feeType'] === undefined) return false;
    if (!('feePercentage' in value) || value['feePercentage'] === undefined) return false;
    if (!('flatFeeCents' in value) || value['flatFeeCents'] === undefined) return false;
    if (!('expectedFeeCents' in value) || value['expectedFeeCents'] === undefined) return false;
    if (!('actualFeeCents' in value) || value['actualFeeCents'] === undefined) return false;
    if (!('outstandingFeeCents' in value) || value['outstandingFeeCents'] === undefined) return false;
    return true;
}

export function ClaimFinancialRowFromJSON(json: any): ClaimFinancialRow {
    return ClaimFinancialRowFromJSONTyped(json, false);
}

export function ClaimFinancialRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimFinancialRow {
    if (json == null) {
        return json;
    }
    return {
        
        'claimId': json['claimId'],
        'claimNumber': json['claimNumber'],
        'insuredName': json['insuredName'],
        'createdAt': json['createdAt'],
        'rcvCents': json['rcvCents'],
        'depreciationCents': json['depreciationCents'],
        'acvCents': json['acvCents'],
        'deductibleCents': json['deductibleCents'],
        'netClaimCents': json['netClaimCents'],
        'recoverableDepreciationCents': json['recoverableDepreciationCents'],
        'nonRecoverableDepreciationCents': json['nonRecoverableDepreciationCents'],
        'netWithRecoverableCents': json['netWithRecoverableCents'],
        'totalPaymentsCents': json['totalPaymentsCents'],
        'carrierPaymentCents': json['carrierPaymentCents'],
        'supplementPaymentCents': json['supplementPaymentCents'],
        'depreciationReleaseCents': json['depreciationReleaseCents'],
        'mortgageReleaseCents': json['mortgageReleaseCents'],
        'otherPaymentCents': json['otherPaymentCents'],
        'feeType': json['feeType'],
        'feePercentage': json['feePercentage'],
        'flatFeeCents': json['flatFeeCents'],
        'expectedFeeCents': json['expectedFeeCents'],
        'actualFeeCents': json['actualFeeCents'],
        'outstandingFeeCents': json['outstandingFeeCents'],
    };
}

export function ClaimFinancialRowToJSON(json: any): ClaimFinancialRow {
    return ClaimFinancialRowToJSONTyped(json, false);
}

export function ClaimFinancialRowToJSONTyped(value?: ClaimFinancialRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'claimNumber': value['claimNumber'],
        'insuredName': value['insuredName'],
        'createdAt': value['createdAt'],
        'rcvCents': value['rcvCents'],
        'depreciationCents': value['depreciationCents'],
        'acvCents': value['acvCents'],
        'deductibleCents': value['deductibleCents'],
        'netClaimCents': value['netClaimCents'],
        'recoverableDepreciationCents': value['recoverableDepreciationCents'],
        'nonRecoverableDepreciationCents': value['nonRecoverableDepreciationCents'],
        'netWithRecoverableCents': value['netWithRecoverableCents'],
        'totalPaymentsCents': value['totalPaymentsCents'],
        'carrierPaymentCents': value['carrierPaymentCents'],
        'supplementPaymentCents': value['supplementPaymentCents'],
        'depreciationReleaseCents': value['depreciationReleaseCents'],
        'mortgageReleaseCents': value['mortgageReleaseCents'],
        'otherPaymentCents': value['otherPaymentCents'],
        'feeType': value['feeType'],
        'feePercentage': value['feePercentage'],
        'flatFeeCents': value['flatFeeCents'],
        'expectedFeeCents': value['expectedFeeCents'],
        'actualFeeCents': value['actualFeeCents'],
        'outstandingFeeCents': value['outstandingFeeCents'],
    };
}

